module.exports = __webpack_public_path__ + "static/media/LP-header-right-mobile.832c27e4.png";